export const rows = [
  {
    id: 1,
    name: "Apple Iphone 12 Pro Max",
    image:
      "https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    stock: 1,
    status: "active",
    price: "$120",
  },
  {
    id: 2,
    name: "Apple Iphone 12 Pro Max",
    image:
      "https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    stock: 1,
    status: "active",
    price: "$120",
  },
  {
    id: 3,
    name: "Apple Iphone 12 Pro Max",
    image:
      "https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    stock: 1,
    status: "active",
    price: "$120",
  },
  {
    id: 4,
    name: "Apple Iphone 12 Pro Max",
    image:
      "https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    stock: 1,
    status: "active",
    price: "$120",
  },
  {
    id: 5,
    name: "Apple Iphone 12 Pro Max",
    image:
      "https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80",
    stock: 1,
    status: "active",
    price: "$120",
  },
];
